import axios from "../util/axios";
import config from "../config/config";

export interface TrainerSubscriptionTrainer {
  id: number;
  title: string;
  slug: string;
  description: string | null;
  paywall_enabled: boolean;
  subscription_description: string | null;
  subscription_amount_cents: number | null;
}

export interface TrainerSubscription {
  id: string;
  created_at: string;
  updated_at: string;
  stripe_subscription_id: string | null;
  status: "ACTIVE" | "INACTIVE" | "CANCELLED";
  trainer: TrainerSubscriptionTrainer;
  user?: {
    id: string;
    email: string;
    name: string;
  };
}

export interface ListTrainerSubscriptionsResponse {
  message: string;
  error: boolean;
  results: TrainerSubscription[];
}

export async function getSubscriptionsByTrainer(
  trainerId: number,
): Promise<ListTrainerSubscriptionsResponse> {
  const response = await axios.get<ListTrainerSubscriptionsResponse>(
    `${config.defaults.api_url}/trainer-subscription/trainer/${trainerId}`,
  );
  return response.data;
}
